const prob = [
    {
        "contestId": 1623,
        "index": "C",
        "name": "Balanced Stone Heaps",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1600,
        "tags": [
            "binary search",
            "greedy"
        ]
    },
    {
        "contestId": 1623,
        "index": "B",
        "name": "Game on Ranges",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "brute force",
            "dfs and similar",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1623,
        "index": "A",
        "name": "Robot Cleaner",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1622,
        "index": "C",
        "name": "Set or Decrease",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "binary search",
            "brute force",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1622,
        "index": "B",
        "name": "Berland Music",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "data structures",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1622,
        "index": "A",
        "name": "Construct a Rectangle",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "geometry",
            "math"
        ]
    },
    {
        "contestId": 1621,
        "index": "C",
        "name": "Hidden Permutations",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "dfs and similar",
            "interactive",
            "math"
        ]
    },
    {
        "contestId": 1621,
        "index": "B",
        "name": "Integers Shop",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "data structures",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1621,
        "index": "A",
        "name": "Stable Arrangement of Rooks",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1620,
        "index": "C",
        "name": "BA-String",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1620,
        "index": "B",
        "name": "Triangles on a Rectangle",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "geometry",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1620,
        "index": "A",
        "name": "Equal or Not Equal",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "dsu",
            "implementation"
        ]
    },
    {
        "contestId": 1619,
        "index": "E",
        "name": "MEX and Increments",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "data structures",
            "dp",
            "greedy",
            "implementation",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1619,
        "index": "D",
        "name": "New Year's Problem",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "binary search",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1619,
        "index": "C",
        "name": "Wrong Addition",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1619,
        "index": "B",
        "name": "Squares and Cubes",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1619,
        "index": "A",
        "name": "Square String?",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1618,
        "index": "E",
        "name": "Singers' Tour",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1618,
        "index": "D",
        "name": "Array and Operations",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1618,
        "index": "C",
        "name": "Paint the Array",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1618,
        "index": "B",
        "name": "Missing Bigram",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1618,
        "index": "A",
        "name": "Polycarp and Sums of Subsequences",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1617,
        "index": "D1",
        "name": "Too Many Impostors (easy version)",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "implementation",
            "interactive"
        ]
    },
    {
        "contestId": 1617,
        "index": "C",
        "name": "Paprika and Permutation",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1300,
        "tags": [
            "binary search",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1617,
        "index": "B",
        "name": "GCD Problem",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "brute force",
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1617,
        "index": "A",
        "name": "Forbidden Subsequence",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "sortings",
            "strings"
        ]
    },
    {
        "contestId": 1616,
        "index": "C",
        "name": "Representative Edges",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "brute force",
            "geometry",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1616,
        "index": "B",
        "name": "Mirror in the String",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1616,
        "index": "A",
        "name": "Integer Diversity",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1615,
        "index": "C",
        "name": "Menorah",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1600,
        "tags": [
            "brute force",
            "graphs",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1615,
        "index": "B",
        "name": "And It's Non-Zero",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "bitmasks",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1615,
        "index": "A",
        "name": "Closing The Gap",
        "type": "PROGRAMMING",
        "points": 250,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1614,
        "index": "C",
        "name": "Divan and bitwise operations",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "bitmasks",
            "combinatorics",
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1614,
        "index": "B",
        "name": "Divan and a New Project ",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "sortings"
        ]
    },
    {
        "contestId": 1614,
        "index": "A",
        "name": "Divan and a Store",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1613,
        "index": "C",
        "name": "Poisoned Dagger",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "binary search"
        ]
    },
    {
        "contestId": 1613,
        "index": "B",
        "name": "Absent Remainder",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1613,
        "index": "A",
        "name": "Long Comparison",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1612,
        "index": "D",
        "name": "X-Magic Pair",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1612,
        "index": "C",
        "name": "Chat Ban",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "binary search",
            "math"
        ]
    },
    {
        "contestId": 1612,
        "index": "B",
        "name": "Special Permutation",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1612,
        "index": "A",
        "name": "Distance",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "brute force",
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1611,
        "index": "F",
        "name": "ATM and Students",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "binary search",
            "data structures",
            "two pointers"
        ]
    },
    {
        "contestId": 1611,
        "index": "E1",
        "name": "Escape The Maze (easy version)",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "dfs and similar",
            "greedy",
            "shortest paths",
            "trees",
            "two pointers"
        ]
    },
    {
        "contestId": 1611,
        "index": "D",
        "name": "Weights Assignment For Tree Edges",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "trees"
        ]
    },
    {
        "contestId": 1611,
        "index": "C",
        "name": "Polycarp Recovers the Permutation",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1611,
        "index": "B",
        "name": "Team Composition: Programmers and Mathematicians",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "binary search",
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1611,
        "index": "A",
        "name": "Make Even",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1610,
        "index": "C",
        "name": "Keshi Is Throwing a Party",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "binary search",
            "greedy"
        ]
    },
    {
        "contestId": 1610,
        "index": "B",
        "name": "Kalindrome Array",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1610,
        "index": "A",
        "name": "Anti Light's Cell Guessing",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1609,
        "index": "D",
        "name": "Social Network",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1600,
        "tags": [
            "dsu",
            "graphs",
            "greedy",
            "implementation",
            "trees"
        ]
    },
    {
        "contestId": 1609,
        "index": "C",
        "name": "Complex Market Analysis",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "binary search",
            "dp",
            "implementation",
            "number theory",
            "schedules",
            "two pointers"
        ]
    },
    {
        "contestId": 1609,
        "index": "B",
        "name": "William the Vigilant",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1609,
        "index": "A",
        "name": "Divide and Multiply",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "greedy",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1608,
        "index": "C",
        "name": "Game Master",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "data structures",
            "dfs and similar",
            "dp",
            "graphs",
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1608,
        "index": "B",
        "name": "Build the Permutation",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1608,
        "index": "A",
        "name": "Find Array",
        "type": "PROGRAMMING",
        "points": 250,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1607,
        "index": "E",
        "name": "Robot on the Board 1",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1607,
        "index": "D",
        "name": "Blue-Red Permutation",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1607,
        "index": "C",
        "name": "Minimum Extraction",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "sortings"
        ]
    },
    {
        "contestId": 1607,
        "index": "B",
        "name": "Odd Grasshopper",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1607,
        "index": "A",
        "name": "Linear Keyboard",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1606,
        "index": "C",
        "name": "Banknotes",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "greedy",
            "number theory"
        ]
    },
    {
        "contestId": 1606,
        "index": "B",
        "name": "Update Files",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1606,
        "index": "A",
        "name": "AB Balance",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "strings"
        ]
    },
    {
        "contestId": 1605,
        "index": "C",
        "name": "Dominant Character",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "brute force",
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1605,
        "index": "B",
        "name": "Reverse Sort",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1605,
        "index": "A",
        "name": "A.M. Deviation",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1604,
        "index": "B",
        "name": "XOR Specia-LIS-t",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": []
    },
    {
        "contestId": 1604,
        "index": "A",
        "name": "Era",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1603,
        "index": "B",
        "name": "Moderate Modular Mode",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1603,
        "index": "A",
        "name": "Di-visible Confusion",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1602,
        "index": "B",
        "name": "Divine Array",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1602,
        "index": "A",
        "name": "Two Subsequences",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1601,
        "index": "A",
        "name": "Array Elimination",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "bitmasks",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1600,
        "index": "J",
        "name": "Robot Factory",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "bitmasks",
            "dfs and similar"
        ]
    },
    {
        "contestId": 1598,
        "index": "D",
        "name": "Training Session",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "combinatorics",
            "data structures",
            "geometry",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1598,
        "index": "C",
        "name": "Delete Two Elements",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "data structures",
            "dp",
            "implementation",
            "math",
            "two pointers"
        ]
    },
    {
        "contestId": 1598,
        "index": "B",
        "name": "Groups",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1598,
        "index": "A",
        "name": "Computer Game",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "brute force",
            "dfs and similar",
            "dp",
            "implementation"
        ]
    },
    {
        "contestId": 1594,
        "index": "E1",
        "name": "Rubik's Cube Coloring (easy version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "combinatorics",
            "math"
        ]
    },
    {
        "contestId": 1594,
        "index": "D",
        "name": "The Number of Imposters",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "dsu",
            "graphs"
        ]
    },
    {
        "contestId": 1594,
        "index": "C",
        "name": "Make Them Equal",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1200,
        "tags": [
            "brute force",
            "greedy",
            "math",
            "strings"
        ]
    },
    {
        "contestId": 1594,
        "index": "B",
        "name": "Special Numbers",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "bitmasks",
            "math"
        ]
    },
    {
        "contestId": 1594,
        "index": "A",
        "name": "Consecutive Sum Riddle",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1593,
        "index": "E",
        "name": "Gardener and Tree",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "brute force",
            "data structures",
            "dfs and similar",
            "greedy",
            "implementation",
            "trees"
        ]
    },
    {
        "contestId": 1593,
        "index": "D1",
        "name": "All are Same",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1593,
        "index": "C",
        "name": "Save More Mice",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "binary search",
            "greedy",
            "greedy"
        ]
    },
    {
        "contestId": 1593,
        "index": "B",
        "name": "Make it Divisible by 25",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "dfs and similar",
            "dp",
            "greedy",
            "math",
            "math"
        ]
    },
    {
        "contestId": 1593,
        "index": "A",
        "name": "Elections",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1592,
        "index": "C",
        "name": "Bakry and Partitioning",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        "contestId": 1592,
        "index": "B",
        "name": "Hemose Shopping",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "dsu",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1592,
        "index": "A",
        "name": "Gamer Hemose",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "binary search",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1585,
        "index": "C",
        "name": "Minimize Distance",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1300,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1585,
        "index": "B",
        "name": "Array Eversion",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1585,
        "index": "A",
        "name": "Life of a Flower",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1584,
        "index": "C",
        "name": "Two Arrays",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1584,
        "index": "B",
        "name": "Coloring Rectangles",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1584,
        "index": "A",
        "name": "Mathematical Addition",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1583,
        "index": "D",
        "name": "Omkar and the Meaning of Life",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "interactive"
        ]
    },
    {
        "contestId": 1583,
        "index": "C",
        "name": "Omkar and Determination",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "data structures",
            "dp"
        ]
    },
    {
        "contestId": 1583,
        "index": "B",
        "name": "Omkar and Heavenly Tree",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "trees"
        ]
    },
    {
        "contestId": 1583,
        "index": "A",
        "name": "Windblume Ode",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1582,
        "index": "F1",
        "name": "Korney Korneevich and XOR (easy version)",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1800,
        "tags": [
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1582,
        "index": "D",
        "name": "Vupsen, Pupsen and 0",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1582,
        "index": "C",
        "name": "Grandma Capa Knits a Scarf",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1200,
        "tags": [
            "brute force",
            "data structures",
            "greedy",
            "strings",
            "two pointers"
        ]
    },
    {
        "contestId": 1582,
        "index": "B",
        "name": "Luntik and Subsequences",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 900,
        "tags": [
            "combinatorics",
            "math"
        ]
    },
    {
        "contestId": 1582,
        "index": "A",
        "name": "Luntik and Concerts",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1581,
        "index": "B",
        "name": "Diameter of Graph",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "graphs",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1581,
        "index": "A",
        "name": "CQXYM Count Permutations",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "combinatorics",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1580,
        "index": "A",
        "name": "Portal",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1700,
        "tags": [
            "brute force",
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1579,
        "index": "F",
        "name": "Array Stabilization (AND version)",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "brute force",
            "graphs",
            "math",
            "number theory",
            "shortest paths"
        ]
    },
    {
        "contestId": 1579,
        "index": "E2",
        "name": "Array Optimization by Deque",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1579,
        "index": "E1",
        "name": "Permutation Minimization by Deque",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1579,
        "index": "D",
        "name": "Productive Meeting",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "graphs",
            "greedy"
        ]
    },
    {
        "contestId": 1579,
        "index": "C",
        "name": "Ticks",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1579,
        "index": "B",
        "name": "Shifting Sort",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1579,
        "index": "A",
        "name": "Casimir's String Solitaire",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math",
            "strings"
        ]
    },
    {
        "contestId": 1578,
        "index": "H",
        "name": "Higher Order Functions",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1578,
        "index": "E",
        "name": "Easy Scheduling",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1575,
        "index": "J",
        "name": "Jeopardy of Dropped Balls",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "binary search",
            "brute force",
            "dsu",
            "implementation"
        ]
    },
    {
        "contestId": 1575,
        "index": "D",
        "name": "Divisible by Twenty-Five",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "brute force",
            "dfs and similar",
            "dp"
        ]
    },
    {
        "contestId": 1575,
        "index": "A",
        "name": "Another Sorting Problem",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "data structures",
            "sortings",
            "strings"
        ]
    },
    {
        "contestId": 1574,
        "index": "C",
        "name": "Slay the Dragon",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "binary search",
            "greedy",
            "sortings",
            "ternary search"
        ]
    },
    {
        "contestId": 1574,
        "index": "B",
        "name": "Combinatorics Homework",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "combinatorics",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1574,
        "index": "A",
        "name": "Regular Bracket Sequences",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1573,
        "index": "B",
        "name": "Swaps",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1573,
        "index": "A",
        "name": "Countdown",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1572,
        "index": "A",
        "name": "Book",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1800,
        "tags": [
            "binary search",
            "brute force",
            "data structures",
            "dp",
            "graphs",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1571,
        "index": "E",
        "name": "Fix the String",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "*special",
            "bitmasks",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1571,
        "index": "D",
        "name": "Sweepstake",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "*special",
            "brute force",
            "constructive algorithms",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1571,
        "index": "C",
        "name": "Rhyme",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "*special",
            "implementation"
        ]
    },
    {
        "contestId": 1571,
        "index": "B",
        "name": "Epic Novel",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "*special",
            "math"
        ]
    },
    {
        "contestId": 1569,
        "index": "C",
        "name": "Jury Meeting",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "combinatorics",
            "math"
        ]
    },
    {
        "contestId": 1569,
        "index": "B",
        "name": "Chess Tournament",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1569,
        "index": "A",
        "name": "Balanced Substring",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1567,
        "index": "C",
        "name": "Carrying Conundrum",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "bitmasks",
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1567,
        "index": "B",
        "name": "MEXor Mixup",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "bitmasks",
            "greedy"
        ]
    },
    {
        "contestId": 1567,
        "index": "A",
        "name": "Domino Disaster",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1566,
        "index": "D2",
        "name": "Seating Arrangements (hard version) ",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1600,
        "tags": [
            "data structures",
            "greedy",
            "implementation",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1566,
        "index": "D1",
        "name": "Seating Arrangements (easy version) ",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1100,
        "tags": [
            "data structures",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1566,
        "index": "C",
        "name": "MAX-MEX Cut",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1566,
        "index": "B",
        "name": "MIN-MEX Cut",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1566,
        "index": "A",
        "name": "Median Maximization",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "binary search",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1562,
        "index": "D1",
        "name": "Two Hundred Twenty One (easy version)",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1700,
        "tags": [
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1562,
        "index": "C",
        "name": "Rings",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1562,
        "index": "B",
        "name": "Scenes From a Memory",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "brute force",
            "constructive algorithms",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1562,
        "index": "A",
        "name": "The Miracle and the Sleeper",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1561,
        "index": "D1",
        "name": "Up the Strip (simplified version)",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "brute force",
            "data structures",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1561,
        "index": "C",
        "name": "Deep Down Below",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1300,
        "tags": [
            "binary search",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1561,
        "index": "A",
        "name": "Simply Strange Sort",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1560,
        "index": "E",
        "name": "Polycarp and String Transformation",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "binary search",
            "implementation",
            "sortings",
            "strings"
        ]
    },
    {
        "contestId": 1560,
        "index": "D",
        "name": "Make a Power of Two",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "greedy",
            "math",
            "strings"
        ]
    },
    {
        "contestId": 1560,
        "index": "C",
        "name": "Infinity Table",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1560,
        "index": "B",
        "name": "Who's Opposite?",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1560,
        "index": "A",
        "name": "Dislike of Threes",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1559,
        "index": "D1",
        "name": "Mocha and Diana (Easy Version)",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "brute force",
            "constructive algorithms",
            "dsu",
            "graphs",
            "greedy",
            "trees"
        ]
    },
    {
        "contestId": 1559,
        "index": "C",
        "name": "Mocha and Hiking",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "graphs"
        ]
    },
    {
        "contestId": 1559,
        "index": "B",
        "name": "Mocha and Red and Blue",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 900,
        "tags": [
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1559,
        "index": "A",
        "name": "Mocha and Math",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1558,
        "index": "A",
        "name": "Charmed by the Game",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1557,
        "index": "C",
        "name": "Moamen and XOR",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "combinatorics",
            "dp",
            "math",
            "matrices"
        ]
    },
    {
        "contestId": 1557,
        "index": "B",
        "name": "Moamen and k-subarrays",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1557,
        "index": "A",
        "name": "Ezzat and Two Subsequences",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1556,
        "index": "D",
        "name": "Take a Guess",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1800,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "interactive",
            "math"
        ]
    },
    {
        "contestId": 1556,
        "index": "C",
        "name": "Compressed Bracket Sequence",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1800,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1556,
        "index": "B",
        "name": "Take Your Places!",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1556,
        "index": "A",
        "name": "A Variety of Operations",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1555,
        "index": "D",
        "name": "Say No to Palindromes",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "brute force",
            "constructive algorithms",
            "dp",
            "strings"
        ]
    },
    {
        "contestId": 1555,
        "index": "C",
        "name": "Coin Rows",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "brute force",
            "constructive algorithms",
            "dp",
            "implementation"
        ]
    },
    {
        "contestId": 1555,
        "index": "B",
        "name": "Two Tables",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "brute force"
        ]
    },
    {
        "contestId": 1555,
        "index": "A",
        "name": "PizzaForces",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1554,
        "index": "D",
        "name": "Diane",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1554,
        "index": "C",
        "name": "Mikasa",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1800,
        "tags": [
            "binary search",
            "bitmasks",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1554,
        "index": "B",
        "name": "Cobb",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "brute force",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1554,
        "index": "A",
        "name": "Cherry",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1553,
        "index": "D",
        "name": "Backspace",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "dp",
            "greedy",
            "strings",
            "two pointers"
        ]
    },
    {
        "contestId": 1553,
        "index": "C",
        "name": "Penalty",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "bitmasks",
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1553,
        "index": "B",
        "name": "Reverse String",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "brute force",
            "dp",
            "hashing",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1553,
        "index": "A",
        "name": "Digits Sum",
        "type": "PROGRAMMING",
        "points": 250,
        "rating": 800,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1552,
        "index": "D",
        "name": "Array Differentiation",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dfs and similar",
            "dp",
            "graphs",
            "math"
        ]
    },
    {
        "contestId": 1552,
        "index": "C",
        "name": "Maximize the Intersections",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "combinatorics",
            "constructive algorithms",
            "geometry",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1552,
        "index": "B",
        "name": "Running for Gold",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "combinatorics",
            "graphs",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1552,
        "index": "A",
        "name": "Subsequence Permutation",
        "type": "PROGRAMMING",
        "points": 250,
        "rating": 800,
        "tags": [
            "sortings",
            "strings"
        ]
    },
    {
        "contestId": 1551,
        "index": "D1",
        "name": "Domino (easy version)",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1551,
        "index": "C",
        "name": "Interesting Story",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "greedy",
            "sortings",
            "strings"
        ]
    },
    {
        "contestId": 1551,
        "index": "B2",
        "name": "Wonderful Coloring - 2",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "binary search",
            "constructive algorithms",
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1551,
        "index": "B1",
        "name": "Wonderful Coloring - 1",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1551,
        "index": "A",
        "name": "Polycarp and Coins",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1550,
        "index": "C",
        "name": "Manhattan Subarrays",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "brute force",
            "geometry",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1550,
        "index": "B",
        "name": "Maximum Cost Deletion",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1550,
        "index": "A",
        "name": "Find The Array",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1549,
        "index": "B",
        "name": "Gregor and the Pawn Game",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "dfs and similar",
            "dp",
            "flows",
            "graph matchings",
            "graphs",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1549,
        "index": "A",
        "name": "Gregor and Cryptography",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1548,
        "index": "B",
        "name": "Integers Have Friends",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "binary search",
            "data structures",
            "divide and conquer",
            "math",
            "number theory",
            "two pointers"
        ]
    },
    {
        "contestId": 1548,
        "index": "A",
        "name": "Web of Lies",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1400,
        "tags": [
            "brute force",
            "graphs",
            "greedy"
        ]
    },
    {
        "contestId": 1547,
        "index": "E",
        "name": "Air Conditioners",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "data structures",
            "dp",
            "implementation",
            "shortest paths",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1547,
        "index": "D",
        "name": "Co-growing Sequence",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1547,
        "index": "C",
        "name": "Pair Programming",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1547,
        "index": "B",
        "name": "Alphabetical Strings",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1547,
        "index": "A",
        "name": "Shortest Path with Obstacle",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1546,
        "index": "B",
        "name": "AquaMoon and Stolen String",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "interactive",
            "math"
        ]
    },
    {
        "contestId": 1546,
        "index": "A",
        "name": "AquaMoon and Two Arrays",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "greedy"
        ]
    },
    {
        "contestId": 1545,
        "index": "A",
        "name": "AquaMoon and Strange Sort",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "sortings"
        ]
    },
    {
        "contestId": 1543,
        "index": "D1",
        "name": "RPD and Rap Sheet (Easy Version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "interactive",
            "math"
        ]
    },
    {
        "contestId": 1543,
        "index": "B",
        "name": "Customising the Track",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 900,
        "tags": [
            "combinatorics",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1543,
        "index": "A",
        "name": "Exciting Bets",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1542,
        "index": "C",
        "name": "Strange Function",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1542,
        "index": "B",
        "name": "Plus and Multiply",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1542,
        "index": "A",
        "name": "Odd Set",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1541,
        "index": "B",
        "name": "Pleasant Pairs",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "brute force",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1541,
        "index": "A",
        "name": "Pretty Permutations",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1540,
        "index": "A",
        "name": "Great Graphs",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "graphs",
            "greedy",
            "shortest paths",
            "sortings"
        ]
    },
    {
        "contestId": 1539,
        "index": "D",
        "name": "PriceFixed",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "binary search",
            "greedy",
            "implementation",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1539,
        "index": "C",
        "name": "Stable Groups",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1200,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1539,
        "index": "B",
        "name": "Love Song",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1539,
        "index": "A",
        "name": "Contest Start",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "combinatorics",
            "geometry",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1538,
        "index": "F",
        "name": "Interesting Function",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "binary search",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1538,
        "index": "D",
        "name": "Another Problem About Dividing Numbers",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1538,
        "index": "C",
        "name": "Number of Pairs",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "binary search",
            "data structures",
            "math",
            "two pointers"
        ]
    },
    {
        "contestId": 1538,
        "index": "B",
        "name": "Friends and Candies",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1538,
        "index": "A",
        "name": "Stone Game",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1537,
        "index": "E1",
        "name": "Erase and Extend (Easy Version)",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1600,
        "tags": [
            "binary search",
            "brute force",
            "dp",
            "greedy",
            "hashing",
            "implementation",
            "string suffix structures",
            "strings",
            "two pointers"
        ]
    },
    {
        "contestId": 1537,
        "index": "D",
        "name": "Deleting Divisors",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "games",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1537,
        "index": "C",
        "name": "Challenging Cliffs",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1537,
        "index": "B",
        "name": "Bad Boy",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 900,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1537,
        "index": "A",
        "name": "Arithmetic Array",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1536,
        "index": "C",
        "name": "Diluc and Kaeya",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "data structures",
            "dp",
            "hashing",
            "number theory"
        ]
    },
    {
        "contestId": 1536,
        "index": "B",
        "name": "Prinzessin der Verurteilung",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "brute force",
            "constructive algorithms",
            "strings"
        ]
    },
    {
        "contestId": 1536,
        "index": "A",
        "name": "Omkar and Bad Story",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1535,
        "index": "D",
        "name": "Playoff Tournament",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "data structures",
            "dfs and similar",
            "dp",
            "implementation",
            "trees"
        ]
    },
    {
        "contestId": 1535,
        "index": "C",
        "name": "Unstable String",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "binary search",
            "dp",
            "greedy",
            "implementation",
            "strings",
            "two pointers"
        ]
    },
    {
        "contestId": 1535,
        "index": "B",
        "name": "Array Reodering",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "brute force",
            "greedy",
            "math",
            "number theory",
            "sortings"
        ]
    },
    {
        "contestId": 1535,
        "index": "A",
        "name": "Fair Playoff",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1534,
        "index": "D",
        "name": "Lost Tree",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "interactive",
            "trees"
        ]
    },
    {
        "contestId": 1534,
        "index": "C",
        "name": "Little Alawn's Puzzle",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1300,
        "tags": [
            "combinatorics",
            "dp",
            "dsu",
            "graphs",
            "math"
        ]
    },
    {
        "contestId": 1534,
        "index": "B",
        "name": "Histogram Ugliness",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1534,
        "index": "A",
        "name": "Colour the Flag",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1530,
        "index": "D",
        "name": "Secret Santa",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "flows",
            "graphs",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1530,
        "index": "C",
        "name": "Pursuit",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "binary search",
            "brute force",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1530,
        "index": "B",
        "name": "Putting Plates",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1530,
        "index": "A",
        "name": "Binary Decimal",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1529,
        "index": "B",
        "name": "Sifid and Strange Subsequences",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1100,
        "tags": [
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1529,
        "index": "A",
        "name": "Eshag Loves Big Arrays",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1528,
        "index": "B",
        "name": "Kavi on Pairing Duty",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1528,
        "index": "A",
        "name": "Parsa's Humongous Tree",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1600,
        "tags": [
            "dfs and similar",
            "divide and conquer",
            "dp",
            "greedy",
            "trees"
        ]
    },
    {
        "contestId": 1527,
        "index": "C",
        "name": "Sequence Pair Weight",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "hashing",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1527,
        "index": "B1",
        "name": "Palindrome Game (easy version)",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "games"
        ]
    },
    {
        "contestId": 1527,
        "index": "A",
        "name": "And Then There Were K",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "bitmasks"
        ]
    },
    {
        "contestId": 1526,
        "index": "C2",
        "name": "Potions (Hard Version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1600,
        "tags": [
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1526,
        "index": "C1",
        "name": "Potions (Easy Version)",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1500,
        "tags": [
            "brute force",
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1526,
        "index": "B",
        "name": "I Hate 1111",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1526,
        "index": "A",
        "name": "Mean Inequality",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "sortings"
        ]
    },
    {
        "contestId": 1525,
        "index": "D",
        "name": "Armchairs",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "dp",
            "flows",
            "graph matchings",
            "greedy"
        ]
    },
    {
        "contestId": 1525,
        "index": "B",
        "name": "Permutation Sort",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1525,
        "index": "A",
        "name": "Potion-making",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1523,
        "index": "C",
        "name": "Compression and Expansion",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "brute force",
            "data structures",
            "greedy",
            "implementation",
            "trees"
        ]
    },
    {
        "contestId": 1523,
        "index": "B",
        "name": "Lord of the Values",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1523,
        "index": "A",
        "name": "Game of Life",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1521,
        "index": "B",
        "name": "Nastia and a Good Array",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1521,
        "index": "A",
        "name": "Nastia and Nearly Good Numbers",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1520,
        "index": "F1",
        "name": "Guess the K-th Zero (Easy version)",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "binary search",
            "interactive"
        ]
    },
    {
        "contestId": 1520,
        "index": "E",
        "name": "Arranging The Sheep",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1520,
        "index": "D",
        "name": "Same Differences",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "data structures",
            "hashing",
            "math"
        ]
    },
    {
        "contestId": 1520,
        "index": "C",
        "name": "Not Adjacent Matrix",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1520,
        "index": "B",
        "name": "Ordinary Numbers",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "brute force",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1520,
        "index": "A",
        "name": "Do Not Be Distracted!",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1519,
        "index": "D",
        "name": "Maximum Sum of Products",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "brute force",
            "dp",
            "implementation",
            "math",
            "two pointers"
        ]
    },
    {
        "contestId": 1519,
        "index": "C",
        "name": "Berland Regional",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "brute force",
            "data structures",
            "greedy",
            "number theory",
            "sortings"
        ]
    },
    {
        "contestId": 1519,
        "index": "B",
        "name": "The Cake Is a Lie",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1519,
        "index": "A",
        "name": "Red and Blue Beans",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1517,
        "index": "D",
        "name": "Explorer Space",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1800,
        "tags": [
            "dp",
            "graphs",
            "shortest paths"
        ]
    },
    {
        "contestId": 1517,
        "index": "C",
        "name": "Fillomino 2",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "dfs and similar",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1517,
        "index": "B",
        "name": "Morning Jogging",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1517,
        "index": "A",
        "name": "Sum of 2050",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1516,
        "index": "C",
        "name": "Baby Ehab Partitions Again",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1516,
        "index": "B",
        "name": "AGAGA XOOORRR",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "bitmasks",
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1516,
        "index": "A",
        "name": "Tit for Tat",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1515,
        "index": "D",
        "name": "Phoenix and Socks",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1500,
        "tags": [
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1515,
        "index": "C",
        "name": "Phoenix and Towers",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1515,
        "index": "B",
        "name": "Phoenix and Puzzle",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "brute force",
            "geometry",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1515,
        "index": "A",
        "name": "Phoenix and Gold",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1514,
        "index": "C",
        "name": "Product 1 Modulo N",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "greedy",
            "number theory"
        ]
    },
    {
        "contestId": 1514,
        "index": "B",
        "name": "AND 0, Sum Big",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "bitmasks",
            "combinatorics",
            "math"
        ]
    },
    {
        "contestId": 1514,
        "index": "A",
        "name": "Perfectly Imperfect Array",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1513,
        "index": "C",
        "name": "Add One",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "dp",
            "matrices"
        ]
    },
    {
        "contestId": 1513,
        "index": "B",
        "name": "AND Sequences",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "bitmasks",
            "combinatorics",
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1513,
        "index": "A",
        "name": "Array and Peaks",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1512,
        "index": "G",
        "name": "Short Task",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "brute force",
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1512,
        "index": "E",
        "name": "Permutation by Sum",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "brute force",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1512,
        "index": "D",
        "name": "Corrupted Array",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1512,
        "index": "C",
        "name": "A-B Palindrome",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1512,
        "index": "B",
        "name": "Almost Rectangle",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1512,
        "index": "A",
        "name": "Spy Detected!",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1511,
        "index": "D",
        "name": "Min Cost String",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "brute force",
            "constructive algorithms",
            "graphs",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1511,
        "index": "C",
        "name": "Yet Another Card Deck",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "brute force",
            "data structures",
            "implementation",
            "trees"
        ]
    },
    {
        "contestId": 1511,
        "index": "B",
        "name": "GCD Length",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1511,
        "index": "A",
        "name": "Review Site",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1510,
        "index": "K",
        "name": "King's Task",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "brute force",
            "graphs",
            "implementation"
        ]
    },
    {
        "contestId": 1509,
        "index": "C",
        "name": "The Sports Festival",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1800,
        "tags": [
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1509,
        "index": "B",
        "name": "TMT Document",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1509,
        "index": "A",
        "name": "Average Height",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1508,
        "index": "B",
        "name": "Almost Sorted",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "binary search",
            "combinatorics",
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1506,
        "index": "E",
        "name": "Restoring the Permutation",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1506,
        "index": "D",
        "name": "Epic Transformation",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1506,
        "index": "C",
        "name": "Double-ended Strings",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1506,
        "index": "B",
        "name": "Partial Replacement",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1506,
        "index": "A",
        "name": "Strange Table",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1505,
        "index": "E",
        "name": "Cakewalk",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "*special",
            "greedy",
            "implementation",
            "shortest paths"
        ]
    },
    {
        "contestId": 1505,
        "index": "D",
        "name": "Xenolith? Hippodrome?",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "*special",
            "number theory"
        ]
    },
    {
        "contestId": 1505,
        "index": "C",
        "name": "Fibonacci Words",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "*special",
            "implementation"
        ]
    },
    {
        "contestId": 1505,
        "index": "B",
        "name": "DMCA",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "*special",
            "implementation",
            "number theory"
        ]
    },
    {
        "contestId": 1505,
        "index": "A",
        "name": "Is it rated - 2",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "*special",
            "implementation",
            "interactive"
        ]
    },
    {
        "contestId": 1504,
        "index": "B",
        "name": "Flip the Bits",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1504,
        "index": "A",
        "name": " Déjà Vu",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "strings"
        ]
    },
    {
        "contestId": 1503,
        "index": "B",
        "name": "3-Coloring",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "games",
            "interactive"
        ]
    },
    {
        "contestId": 1503,
        "index": "A",
        "name": "Balance the Bits",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1501,
        "index": "B",
        "name": "Napoleon Cake",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "dp",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1501,
        "index": "A",
        "name": "Alexey and Train",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1500,
        "index": "A",
        "name": "Going Home",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1800,
        "tags": [
            "brute force",
            "hashing",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1499,
        "index": "C",
        "name": "Minimum Grid Path",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "brute force",
            "data structures",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1499,
        "index": "B",
        "name": "Binary Removals",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1499,
        "index": "A",
        "name": "Domino on Windowsill",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "combinatorics",
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1498,
        "index": "C",
        "name": "Planar Reflections",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1600,
        "tags": [
            "brute force",
            "data structures",
            "dp"
        ]
    },
    {
        "contestId": 1498,
        "index": "B",
        "name": "Box Fitting",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "binary search",
            "bitmasks",
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1498,
        "index": "A",
        "name": "GCD Sum",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1497,
        "index": "E1",
        "name": "Square-free division (easy version)",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "data structures",
            "dp",
            "greedy",
            "math",
            "number theory",
            "two pointers"
        ]
    },
    {
        "contestId": 1497,
        "index": "C2",
        "name": "k-LCM (hard version)",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1497,
        "index": "C1",
        "name": "k-LCM (easy version)",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1497,
        "index": "B",
        "name": "M-arrays",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1497,
        "index": "A",
        "name": "Meximization",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "data structures",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1496,
        "index": "B",
        "name": "Max and Mex",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1496,
        "index": "A",
        "name": "Split it!",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1495,
        "index": "A",
        "name": "Diamond Miner",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1200,
        "tags": [
            "geometry",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1494,
        "index": "B",
        "name": "Berland Crossword",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "bitmasks",
            "brute force",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1494,
        "index": "A",
        "name": "ABC String",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "bitmasks",
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1493,
        "index": "B",
        "name": "Planet Lapituletti",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1300,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1493,
        "index": "A",
        "name": "Anti-knapsack",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1492,
        "index": "C",
        "name": "Maximum width",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "binary search",
            "data structures",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1492,
        "index": "B",
        "name": "Card Deck",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "data structures",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1492,
        "index": "A",
        "name": "Three swimmers",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1491,
        "index": "D",
        "name": "Zookeeper and The Infinite Zoo",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1800,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1491,
        "index": "C",
        "name": "Pekora and Trampoline",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "brute force",
            "data structures",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1491,
        "index": "B",
        "name": "Minimal Cost",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1491,
        "index": "A",
        "name": "K-th Largest Value",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1490,
        "index": "F",
        "name": "Equalize the Array",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "binary search",
            "data structures",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1490,
        "index": "E",
        "name": "Accidental Victory",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "binary search",
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1490,
        "index": "D",
        "name": "Permutation Transformation",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "dfs and similar",
            "divide and conquer",
            "implementation"
        ]
    },
    {
        "contestId": 1490,
        "index": "C",
        "name": "Sum of Cubes",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "binary search",
            "brute force",
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1490,
        "index": "B",
        "name": "Balanced Remainders",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1490,
        "index": "A",
        "name": "Dense Array",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1488,
        "index": "B",
        "name": "RBS Deletion",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "*special",
            "greedy"
        ]
    },
    {
        "contestId": 1488,
        "index": "A",
        "name": "From Zero To Y",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "*special",
            "math"
        ]
    },
    {
        "contestId": 1487,
        "index": "D",
        "name": "Pythagorean Triples",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "binary search",
            "brute force",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1487,
        "index": "C",
        "name": "Minimum Ties",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "brute force",
            "constructive algorithms",
            "dfs and similar",
            "graphs",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1487,
        "index": "B",
        "name": "Cat Cycle",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1487,
        "index": "A",
        "name": "Arena",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1486,
        "index": "C1",
        "name": "Guessing the Greatest (easy version)",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1600,
        "tags": [
            "binary search",
            "interactive"
        ]
    },
    {
        "contestId": 1486,
        "index": "B",
        "name": "Eastern Exhibition",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "binary search",
            "geometry",
            "shortest paths",
            "sortings"
        ]
    },
    {
        "contestId": 1486,
        "index": "A",
        "name": "Shifting Stacks",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1485,
        "index": "C",
        "name": "Floor and Mod",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "binary search",
            "brute force",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1485,
        "index": "B",
        "name": "Replace and Keep Sorted",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1485,
        "index": "A",
        "name": "Add and Divide",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "brute force",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1482,
        "index": "C",
        "name": "Basic Diplomacy",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1482,
        "index": "B",
        "name": "Restore Modulo",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1482,
        "index": "A",
        "name": "Prison Break",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1481,
        "index": "C",
        "name": "Fence Painting",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1481,
        "index": "B",
        "name": "New Colony",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1100,
        "tags": [
            "brute force",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1481,
        "index": "A",
        "name": "Space Navigation ",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1480,
        "index": "B",
        "name": "The Great Hero",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1480,
        "index": "A",
        "name": "Yet Another String Game",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "games",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1479,
        "index": "A",
        "name": "Searching Local Minimum",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1700,
        "tags": [
            "binary search",
            "interactive",
            "ternary search"
        ]
    },
    {
        "contestId": 1478,
        "index": "C",
        "name": "Nezzar and Symmetric Array",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "implementation",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1478,
        "index": "B",
        "name": "Nezzar and Lucky Number",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1478,
        "index": "A",
        "name": "Nezzar and Colorful Balls",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "greedy"
        ]
    },
    {
        "contestId": 1477,
        "index": "A",
        "name": "Nezzar and Board",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1476,
        "index": "D",
        "name": "Journey",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "dfs and similar",
            "dp",
            "dsu",
            "implementation"
        ]
    },
    {
        "contestId": 1476,
        "index": "C",
        "name": "Longest Simple Cycle",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        "contestId": 1476,
        "index": "B",
        "name": "Inflation",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "binary search",
            "brute force",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1476,
        "index": "A",
        "name": "K-divisible Sum",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "binary search",
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1475,
        "index": "E",
        "name": "Advertising Agency",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "combinatorics",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1475,
        "index": "D",
        "name": "Cleaning the Phone",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "binary search",
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1475,
        "index": "C",
        "name": "Ball in Berland",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "combinatorics",
            "graphs",
            "math"
        ]
    },
    {
        "contestId": 1475,
        "index": "B",
        "name": "New Year's Number",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "brute force",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1475,
        "index": "A",
        "name": "Odd Divisor",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1474,
        "index": "C",
        "name": "Array Destruction",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "brute force",
            "constructive algorithms",
            "data structures",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1474,
        "index": "B",
        "name": "Different Divisors",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "binary search",
            "constructive algorithms",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1474,
        "index": "A",
        "name": "Puzzle From the Future",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1473,
        "index": "D",
        "name": "Program",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "data structures",
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1473,
        "index": "C",
        "name": "No More Inversions",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1473,
        "index": "B",
        "name": "String LCM",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "math",
            "number theory",
            "strings"
        ]
    },
    {
        "contestId": 1473,
        "index": "A",
        "name": "Replacing Elements",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "implementation",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1472,
        "index": "E",
        "name": "Correct Placement",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "binary search",
            "data structures",
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1472,
        "index": "D",
        "name": "Even-Odd Game",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "dp",
            "games",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1472,
        "index": "C",
        "name": "Long Jumps",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "dp",
            "graphs"
        ]
    },
    {
        "contestId": 1472,
        "index": "B",
        "name": "Fair Division",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "dp",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1472,
        "index": "A",
        "name": "Cards for Friends",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1471,
        "index": "B",
        "name": "Strange List",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1100,
        "tags": [
            "brute force",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1471,
        "index": "A",
        "name": "Strange Partition",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1470,
        "index": "A",
        "name": "Strange Birthday Party",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "binary search",
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1469,
        "index": "D",
        "name": "Ceil Divisions",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "brute force",
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1469,
        "index": "C",
        "name": "Building a Fence",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "dp",
            "greedy",
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1469,
        "index": "B",
        "name": "Red and Blue",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1469,
        "index": "A",
        "name": "Regular Bracket Sequence",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1468,
        "index": "N",
        "name": "Waste Sorting",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1468,
        "index": "K",
        "name": "The Robot",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1468,
        "index": "J",
        "name": "Road Reform",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "dsu",
            "graphs",
            "greedy"
        ]
    },
    {
        "contestId": 1468,
        "index": "F",
        "name": "Full Turn",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "geometry",
            "hashing",
            "number theory"
        ]
    },
    {
        "contestId": 1468,
        "index": "E",
        "name": "Four Segments",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1468,
        "index": "D",
        "name": "Firecrackers",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "binary search",
            "sortings"
        ]
    },
    {
        "contestId": 1468,
        "index": "C",
        "name": "Berpizza",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "data structures",
            "implementation"
        ]
    },
    {
        "contestId": 1467,
        "index": "B",
        "name": "Hills And Valleys",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "brute force",
            "implementation"
        ]
    },
    {
        "contestId": 1467,
        "index": "A",
        "name": "Wizard of Orz",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1466,
        "index": "E",
        "name": "Apollo versus Pan",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1800,
        "tags": [
            "bitmasks",
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1466,
        "index": "D",
        "name": "13th Labour of Heracles",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "data structures",
            "greedy",
            "sortings",
            "trees"
        ]
    },
    {
        "contestId": 1466,
        "index": "C",
        "name": "Canine poetry",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1466,
        "index": "B",
        "name": "Last minute enhancements",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1466,
        "index": "A",
        "name": "Bovine Dilemma",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "geometry",
            "math"
        ]
    },
    {
        "contestId": 1463,
        "index": "C",
        "name": "Busy Robot",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1463,
        "index": "B",
        "name": "Find The Array",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1463,
        "index": "A",
        "name": "Dungeon",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "binary search",
            "math"
        ]
    },
    {
        "contestId": 1462,
        "index": "F",
        "name": "The Treasure of The Segments",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "binary search",
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1462,
        "index": "E2",
        "name": "Close Tuples (hard version)",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "binary search",
            "combinatorics",
            "implementation",
            "math",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1462,
        "index": "E1",
        "name": "Close Tuples (easy version)",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "binary search",
            "combinatorics",
            "math",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1462,
        "index": "D",
        "name": "Add to Neighbour and Remove",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1462,
        "index": "C",
        "name": "Unique Number",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "brute force",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1462,
        "index": "B",
        "name": "Last Year's Substring",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "dp",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1462,
        "index": "A",
        "name": "Favorite Sequence",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1461,
        "index": "D",
        "name": "Divide and Summarize",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "binary search",
            "brute force",
            "data structures",
            "divide and conquer",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1461,
        "index": "C",
        "name": "Random Events",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "dp",
            "math",
            "probabilities"
        ]
    },
    {
        "contestId": 1461,
        "index": "B",
        "name": "Find the Spruce",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        "contestId": 1461,
        "index": "A",
        "name": "String Generation",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1459,
        "index": "B",
        "name": "Move and Turn",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1459,
        "index": "A",
        "name": "Red-Blue Shuffle",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "math",
            "probabilities"
        ]
    },
    {
        "contestId": 1458,
        "index": "A",
        "name": "Row GCD",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1600,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1455,
        "index": "D",
        "name": "Sequence and Swaps",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1455,
        "index": "C",
        "name": "Ping-pong",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "games",
            "math"
        ]
    },
    {
        "contestId": 1455,
        "index": "B",
        "name": "Jumps",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1455,
        "index": "A",
        "name": "Strange Functions",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1454,
        "index": "D",
        "name": "Number into Sequence",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1454,
        "index": "C",
        "name": "Sequence Transformation",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1454,
        "index": "B",
        "name": "Unique Bid Auction",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1454,
        "index": "A",
        "name": "Special Permutation",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "probabilities"
        ]
    },
    {
        "contestId": 1453,
        "index": "C",
        "name": "Triangles",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1453,
        "index": "B",
        "name": "Suffix Operations",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1453,
        "index": "A",
        "name": "Cancel the Trains",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1452,
        "index": "D",
        "name": "Radio Towers",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1452,
        "index": "C",
        "name": "Two Brackets",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1452,
        "index": "B",
        "name": "Toy Blocks",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "binary search",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1452,
        "index": "A",
        "name": "Robot Program",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1451,
        "index": "D",
        "name": "Circle Game",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1700,
        "tags": [
            "games",
            "geometry",
            "math"
        ]
    },
    {
        "contestId": 1451,
        "index": "C",
        "name": "String Equality",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "dp",
            "greedy",
            "hashing",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1451,
        "index": "B",
        "name": "Non-Substring Subsequence",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 900,
        "tags": [
            "dp",
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1451,
        "index": "A",
        "name": "Subtract or Divide",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1450,
        "index": "D",
        "name": "Rating Compression",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1800,
        "tags": [
            "binary search",
            "data structures",
            "greedy",
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1450,
        "index": "B",
        "name": "Balls of Steel",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1000,
        "tags": [
            "brute force",
            "geometry",
            "greedy"
        ]
    },
    {
        "contestId": 1450,
        "index": "A",
        "name": "Avoid Trygub",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "sortings"
        ]
    },
    {
        "contestId": 1447,
        "index": "B",
        "name": "Numbers Box",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1447,
        "index": "A",
        "name": "Add Candies",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1446,
        "index": "B",
        "name": "Catching Cheaters",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "dp",
            "strings"
        ]
    },
    {
        "contestId": 1446,
        "index": "A",
        "name": "Knapsack",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1445,
        "index": "B",
        "name": "Elimination",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1445,
        "index": "A",
        "name": "Array Rearrangment",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1444,
        "index": "A",
        "name": "Division",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "brute force",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1443,
        "index": "C",
        "name": "The Delivery Dilemma",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "binary search",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1443,
        "index": "B",
        "name": "Saving the City",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "dp",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1443,
        "index": "A",
        "name": "Kids Seating",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1442,
        "index": "B",
        "name": "Identify the Operations",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "combinatorics",
            "data structures",
            "dsu",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1442,
        "index": "A",
        "name": "Extreme Subtraction",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1440,
        "index": "B",
        "name": "Sum of Medians",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1440,
        "index": "A",
        "name": "Buy the String",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1439,
        "index": "A1",
        "name": "Binary Table (Easy Version)",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1438,
        "index": "B",
        "name": "Valerii Against Everyone",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1438,
        "index": "A",
        "name": "Specific Tastes of Andre ",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1437,
        "index": "D",
        "name": "Minimal Height Tree",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "graphs",
            "greedy",
            "shortest paths",
            "trees"
        ]
    },
    {
        "contestId": 1437,
        "index": "C",
        "name": "Chef Monocarp",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "dp",
            "flows",
            "graph matchings",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1437,
        "index": "B",
        "name": "Reverse Binary Strings",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1437,
        "index": "A",
        "name": "Marketing Scheme",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1436,
        "index": "C",
        "name": "Binary Search",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "binary search",
            "combinatorics"
        ]
    },
    {
        "contestId": 1436,
        "index": "B",
        "name": "Prime Square",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1436,
        "index": "A",
        "name": "Reorder",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1433,
        "index": "E",
        "name": "Two Round Dances",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "combinatorics",
            "math"
        ]
    },
    {
        "contestId": 1433,
        "index": "D",
        "name": "Districts Connection",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "dfs and similar"
        ]
    },
    {
        "contestId": 1433,
        "index": "C",
        "name": "Dominant Piranha",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1433,
        "index": "B",
        "name": "Yet Another Bookshelf",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1433,
        "index": "A",
        "name": "Boring Apartments",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1431,
        "index": "D",
        "name": "Used Markers",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "*special",
            "greedy"
        ]
    },
    {
        "contestId": 1431,
        "index": "C",
        "name": "Black Friday",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "*special",
            "implementation"
        ]
    },
    {
        "contestId": 1431,
        "index": "B",
        "name": "Polycarp and the Language of Gods",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "*special",
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1431,
        "index": "A",
        "name": "Selling Hamburgers",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "*special"
        ]
    },
    {
        "contestId": 1430,
        "index": "D",
        "name": "String Deletion",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "binary search",
            "data structures",
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1430,
        "index": "C",
        "name": "Numbers on Whiteboard",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1430,
        "index": "B",
        "name": "Barrels",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1430,
        "index": "A",
        "name": "Number of Apartments",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "brute force",
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1428,
        "index": "C",
        "name": "ABBB",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "brute force",
            "data structures",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1428,
        "index": "B",
        "name": "Belted Rooms",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "graphs",
            "implementation"
        ]
    },
    {
        "contestId": 1428,
        "index": "A",
        "name": "Box is Pull",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1427,
        "index": "B",
        "name": "Chess Cheater",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1400,
        "tags": [
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1427,
        "index": "A",
        "name": "Avoiding Zero",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1426,
        "index": "E",
        "name": "Rock, Paper, Scissors",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "brute force",
            "constructive algorithms",
            "flows",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1426,
        "index": "D",
        "name": "Non-zero Segments",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1426,
        "index": "C",
        "name": "Increase and Copy",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "binary search",
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1426,
        "index": "B",
        "name": "Symmetric Matrix",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1426,
        "index": "A",
        "name": "Floor Number",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1425,
        "index": "H",
        "name": "Huge Boxes of Animal Toys",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1425,
        "index": "F",
        "name": "Flamingoes of Mystery",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "interactive"
        ]
    },
    {
        "contestId": 1425,
        "index": "A",
        "name": "Arena of Greed",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "games",
            "greedy"
        ]
    },
    {
        "contestId": 1424,
        "index": "G",
        "name": "Years",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "data structures",
            "sortings"
        ]
    },
    {
        "contestId": 1423,
        "index": "K",
        "name": "Lonely Numbers",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "binary search",
            "math",
            "number theory",
            "two pointers"
        ]
    },
    {
        "contestId": 1422,
        "index": "C",
        "name": "Bargain",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1422,
        "index": "B",
        "name": "Nice Matrix",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1300,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1422,
        "index": "A",
        "name": "Fence",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "geometry",
            "math"
        ]
    },
    {
        "contestId": 1421,
        "index": "C",
        "name": "Palindromifier",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "strings"
        ]
    },
    {
        "contestId": 1421,
        "index": "B",
        "name": "Putting Bricks in the Wall",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1421,
        "index": "A",
        "name": "XORwice",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "bitmasks",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1420,
        "index": "D",
        "name": "Rescue Nibel!",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1800,
        "tags": [
            "combinatorics",
            "data structures",
            "sortings"
        ]
    },
    {
        "contestId": 1420,
        "index": "C1",
        "name": "Pokémon Army (easy version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1420,
        "index": "B",
        "name": "Rock and Lever",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "bitmasks",
            "math"
        ]
    },
    {
        "contestId": 1420,
        "index": "A",
        "name": "Cubes Sorting",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1419,
        "index": "D2",
        "name": "Sage's Birthday (hard version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "binary search",
            "brute force",
            "constructive algorithms",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1419,
        "index": "D1",
        "name": "Sage's Birthday (easy version)",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1000,
        "tags": [
            "binary search",
            "constructive algorithms",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1419,
        "index": "C",
        "name": "Killjoy",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1419,
        "index": "B",
        "name": "Stairs",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1419,
        "index": "A",
        "name": "Digit Game",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "games",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1418,
        "index": "C",
        "name": "Mortal Kombat Tower",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "dp",
            "graphs",
            "greedy",
            "shortest paths"
        ]
    },
    {
        "contestId": 1418,
        "index": "B",
        "name": "Negative Prefixes",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1418,
        "index": "A",
        "name": "Buying Torches",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1417,
        "index": "B",
        "name": "Two Arrays",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1417,
        "index": "A",
        "name": "Copy-paste",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1416,
        "index": "A",
        "name": "k-Amazing Numbers",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "binary search",
            "data structures",
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1415,
        "index": "C",
        "name": "Bouncing Ball",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "implementation"
        ]
    },
    {
        "contestId": 1415,
        "index": "B",
        "name": "Repainting Street",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1100,
        "tags": [
            "brute force",
            "brute force",
            "greedy"
        ]
    },
    {
        "contestId": 1415,
        "index": "A",
        "name": "Prison Break",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1413,
        "index": "D",
        "name": "Shurikens",
        "type": "PROGRAMMING",
        "points": 2000,
        "rating": 1700,
        "tags": [
            "data structures",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1413,
        "index": "B",
        "name": "A New Technique",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1413,
        "index": "A",
        "name": "Finding Sasuke",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1411,
        "index": "C",
        "name": "Peaceful Rooks",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1700,
        "tags": [
            "dfs and similar",
            "dsu",
            "graphs"
        ]
    },
    {
        "contestId": 1411,
        "index": "B",
        "name": "Fair Numbers",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "brute force",
            "number theory"
        ]
    },
    {
        "contestId": 1411,
        "index": "A",
        "name": "In-game Chat",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1409,
        "index": "E",
        "name": "Two Platforms",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "binary search",
            "dp",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1409,
        "index": "D",
        "name": "Decrease the Sum of Digits",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1409,
        "index": "C",
        "name": "Yet Another Array Restoration",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "brute force",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1409,
        "index": "B",
        "name": "Minimum Product",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "brute force",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1409,
        "index": "A",
        "name": "Yet Another Two Integers Problem",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1408,
        "index": "C",
        "name": "Discrete Acceleration",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "binary search",
            "dp",
            "implementation",
            "math",
            "two pointers"
        ]
    },
    {
        "contestId": 1408,
        "index": "B",
        "name": "Arrays Sum",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1408,
        "index": "A",
        "name": "Circle Coloring",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1407,
        "index": "C",
        "name": "Chocolate Bunny",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "interactive",
            "math",
            "two pointers"
        ]
    },
    {
        "contestId": 1407,
        "index": "B",
        "name": "Big Vova",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "brute force",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1407,
        "index": "A",
        "name": "Ahahahahahahahaha",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1406,
        "index": "C",
        "name": "Link Cut Centroids",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "dfs and similar",
            "graphs",
            "trees"
        ]
    },
    {
        "contestId": 1406,
        "index": "B",
        "name": "Maximum Product",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1406,
        "index": "A",
        "name": "Subset Mex",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1405,
        "index": "B",
        "name": "Array Cancellation",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1405,
        "index": "A",
        "name": "Permutation Forgery",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1404,
        "index": "A",
        "name": "Balanced Bitstring",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1402,
        "index": "A",
        "name": "Fancy Fence",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "*special",
            "data structures",
            "dsu",
            "implementation",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1401,
        "index": "D",
        "name": "Maximum Distributed Tree",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1800,
        "tags": [
            "dfs and similar",
            "dp",
            "greedy",
            "implementation",
            "math",
            "number theory",
            "sortings",
            "trees"
        ]
    },
    {
        "contestId": 1401,
        "index": "C",
        "name": "Mere Array",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory",
            "sortings"
        ]
    },
    {
        "contestId": 1401,
        "index": "B",
        "name": "Ternary Sequence",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1401,
        "index": "A",
        "name": "Distance and Axis",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1400,
        "index": "C",
        "name": "Binary String Reconstruction",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "2-sat",
            "brute force",
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1400,
        "index": "B",
        "name": "RPG Protagonist",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "brute force",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1400,
        "index": "A",
        "name": "String Similarity",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "strings"
        ]
    },
    {
        "contestId": 1399,
        "index": "D",
        "name": "Binary String To Subsequences",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1399,
        "index": "C",
        "name": "Boats Competition",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "brute force",
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1399,
        "index": "B",
        "name": "Gifts Fixing",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1399,
        "index": "A",
        "name": "Remove Smallest",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1398,
        "index": "D",
        "name": "Colored Rectangles",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1398,
        "index": "C",
        "name": "Good Subarrays",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "data structures",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1398,
        "index": "B",
        "name": "Substring Removal Game",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "games",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1398,
        "index": "A",
        "name": "Bad Triangle",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "geometry",
            "math"
        ]
    },
    {
        "contestId": 1397,
        "index": "B",
        "name": "Power Sequence",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "brute force",
            "math",
            "number theory",
            "sortings"
        ]
    },
    {
        "contestId": 1397,
        "index": "A",
        "name": "Juggling Letters",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1396,
        "index": "B",
        "name": "Stoned Game",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "brute force",
            "constructive algorithms",
            "games",
            "greedy"
        ]
    },
    {
        "contestId": 1396,
        "index": "A",
        "name": "Multiples of Length",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "greedy",
            "number theory"
        ]
    },
    {
        "contestId": 1395,
        "index": "C",
        "name": "Boboniu and Bit Operations",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1600,
        "tags": [
            "bitmasks",
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1395,
        "index": "B",
        "name": "Boboniu Plays Chess",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1100,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1395,
        "index": "A",
        "name": "Boboniu Likes to Color Balls",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1394,
        "index": "A",
        "name": "Boboniu Chats with Du",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1800,
        "tags": [
            "dp",
            "greedy",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1393,
        "index": "C",
        "name": "Pinkie Pie Eats Patty-cakes",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1393,
        "index": "B",
        "name": "Applejack and Storages",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1393,
        "index": "A",
        "name": "Rainbow Dash, Fluttershy and Chess Coloring",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1392,
        "index": "D",
        "name": "Omkar and Bed Wars",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1392,
        "index": "C",
        "name": "Omkar and Waterslide",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1392,
        "index": "B",
        "name": "Omkar and Infinity Clock",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1392,
        "index": "A",
        "name": "Omkar and Password",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1391,
        "index": "C",
        "name": "Cyclic Permutations ",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "combinatorics",
            "dp",
            "graphs",
            "math"
        ]
    },
    {
        "contestId": 1391,
        "index": "B",
        "name": "Fix You",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "brute force",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1391,
        "index": "A",
        "name": "Suborrays",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1389,
        "index": "C",
        "name": "Good String",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1389,
        "index": "B",
        "name": "Array Walk",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "brute force",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1389,
        "index": "A",
        "name": "LCM Problem",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1388,
        "index": "C",
        "name": "Uncle Bogdan and Country Happiness",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1800,
        "tags": [
            "dfs and similar",
            "greedy",
            "math",
            "trees"
        ]
    },
    {
        "contestId": 1388,
        "index": "B",
        "name": "Captain Flint and a Long Voyage",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1000,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1388,
        "index": "A",
        "name": "Captain Flint and Crew Recruitment",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "brute force",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1385,
        "index": "D",
        "name": "a-Good String",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "bitmasks",
            "brute force",
            "divide and conquer",
            "dp",
            "implementation"
        ]
    },
    {
        "contestId": 1385,
        "index": "C",
        "name": "Make It Good",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1385,
        "index": "B",
        "name": "Restore the Permutation by Merger",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1385,
        "index": "A",
        "name": "Three Pairwise Maximums",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1384,
        "index": "A",
        "name": "Common Prefixes",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1383,
        "index": "A",
        "name": "String Transformation 1",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "dsu",
            "graphs",
            "greedy",
            "sortings",
            "strings",
            "trees",
            "two pointers"
        ]
    },
    {
        "contestId": 1382,
        "index": "B",
        "name": "Sequential Nim",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1100,
        "tags": [
            "dp",
            "games"
        ]
    },
    {
        "contestId": 1382,
        "index": "A",
        "name": "Common Subsequence",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force"
        ]
    },
    {
        "contestId": 1381,
        "index": "B",
        "name": "Unmerge",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1800,
        "tags": [
            "dp"
        ]
    },
    {
        "contestId": 1381,
        "index": "A2",
        "name": "Prefix Flip (Hard Version)",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "data structures",
            "implementation",
            "strings",
            "two pointers"
        ]
    },
    {
        "contestId": 1381,
        "index": "A1",
        "name": "Prefix Flip (Easy Version)",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "data structures",
            "strings"
        ]
    },
    {
        "contestId": 1380,
        "index": "C",
        "name": "Create The Teams",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1380,
        "index": "B",
        "name": "Universal Solution",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1380,
        "index": "A",
        "name": "Three Indices",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "brute force",
            "data structures"
        ]
    },
    {
        "contestId": 1379,
        "index": "B",
        "name": "Dubious Cyrpto",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1500,
        "tags": [
            "binary search",
            "brute force",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1379,
        "index": "A",
        "name": "Acacius and String",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "brute force",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1375,
        "index": "C",
        "name": "Element Extermination",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy"
        ]
    },
    {
        "contestId": 1375,
        "index": "B",
        "name": "Neighbor Grid",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1375,
        "index": "A",
        "name": "Sign Flipping",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1374,
        "index": "E1",
        "name": "Reading Books (easy version)",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "data structures",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1374,
        "index": "D",
        "name": "Zero Remainder Array",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "math",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1374,
        "index": "C",
        "name": "Move Brackets",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1374,
        "index": "B",
        "name": "Multiply by 2, divide by 6",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1374,
        "index": "A",
        "name": "Required Remainder",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1373,
        "index": "D",
        "name": "Maximum Sum on Even Positions",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "divide and conquer",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1373,
        "index": "C",
        "name": "Pluses and Minuses",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1373,
        "index": "B",
        "name": "01 Game",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "games"
        ]
    },
    {
        "contestId": 1373,
        "index": "A",
        "name": "Donut Shops",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1372,
        "index": "C",
        "name": "Omkar and Baseball",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1372,
        "index": "B",
        "name": "Omkar and Last Class of Math",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1372,
        "index": "A",
        "name": "Omkar and Completion",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1371,
        "index": "D",
        "name": "Grid-00100",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1371,
        "index": "C",
        "name": "A Cookie for You",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1300,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1371,
        "index": "B",
        "name": "Magical Calendar",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1371,
        "index": "A",
        "name": "Magical Sticks",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1370,
        "index": "C",
        "name": "Number Game",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "games",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1370,
        "index": "B",
        "name": "GCD Compression",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1370,
        "index": "A",
        "name": "Maximum GCD",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "implementation",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1369,
        "index": "C",
        "name": "RationalLee",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "greedy",
            "math",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1369,
        "index": "B",
        "name": "AccurateLee",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1369,
        "index": "A",
        "name": "FashionabLee",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "geometry",
            "math"
        ]
    },
    {
        "contestId": 1368,
        "index": "D",
        "name": "AND, OR and square sum",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1368,
        "index": "C",
        "name": "Even Picture",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1368,
        "index": "B",
        "name": "Codeforces Subsequences",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "math",
            "strings"
        ]
    },
    {
        "contestId": 1368,
        "index": "A",
        "name": "C+=",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1367,
        "index": "D",
        "name": "Task On The Board",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1367,
        "index": "C",
        "name": "Social Distance",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1367,
        "index": "B",
        "name": "Even Array",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1367,
        "index": "A",
        "name": "Short Substrings",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1366,
        "index": "C",
        "name": "Palindromic Paths",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1366,
        "index": "B",
        "name": "Shuffle",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "math",
            "two pointers"
        ]
    },
    {
        "contestId": 1366,
        "index": "A",
        "name": "Shovels and Swords",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "binary search",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1365,
        "index": "D",
        "name": "Solve The Maze",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "dfs and similar",
            "dsu",
            "graphs",
            "greedy",
            "implementation",
            "shortest paths"
        ]
    },
    {
        "contestId": 1365,
        "index": "C",
        "name": "Rotation Matching",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1365,
        "index": "B",
        "name": "Trouble Sort",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1365,
        "index": "A",
        "name": "Matrix Game",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1100,
        "tags": [
            "games",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1364,
        "index": "C",
        "name": "Ehab and Prefix MEXs",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy"
        ]
    },
    {
        "contestId": 1364,
        "index": "B",
        "name": "Most socially-distanced subsequence",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1364,
        "index": "A",
        "name": "XXXXX",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "brute force",
            "data structures",
            "number theory",
            "two pointers"
        ]
    },
    {
        "contestId": 1363,
        "index": "C",
        "name": "Game On Leaves",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "games",
            "trees"
        ]
    },
    {
        "contestId": 1363,
        "index": "B",
        "name": "Subsequence Hate",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1363,
        "index": "A",
        "name": "Odd Selection",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1200,
        "tags": [
            "brute force",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1362,
        "index": "C",
        "name": "Johnny and Another Rating Drop",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "bitmasks",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1362,
        "index": "B",
        "name": "Johnny and His Hobbies",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "bitmasks",
            "brute force"
        ]
    },
    {
        "contestId": 1362,
        "index": "A",
        "name": "Johnny and Ancient Computer",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1361,
        "index": "A",
        "name": "Johnny and Contribution",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "graphs",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1360,
        "index": "F",
        "name": "Spy-string",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "bitmasks",
            "brute force",
            "constructive algorithms",
            "dp",
            "hashing",
            "strings"
        ]
    },
    {
        "contestId": 1360,
        "index": "E",
        "name": "Polygon",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "dp",
            "graphs",
            "implementation",
            "shortest paths"
        ]
    },
    {
        "contestId": 1360,
        "index": "D",
        "name": "Buying Shovels",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1360,
        "index": "C",
        "name": "Similar Pairs",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "graph matchings",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1360,
        "index": "B",
        "name": "Honest Coach",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1360,
        "index": "A",
        "name": "Minimal Square",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1359,
        "index": "C",
        "name": "Mixing Water",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "binary search",
            "math"
        ]
    },
    {
        "contestId": 1359,
        "index": "B",
        "name": "New Theatre Square",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1359,
        "index": "A",
        "name": "Berland Poker",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "brute force",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1358,
        "index": "C",
        "name": "Celex Update",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1358,
        "index": "B",
        "name": "Maria Breaks the Self-isolation",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1000,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1358,
        "index": "A",
        "name": "Park Lighting",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1355,
        "index": "D",
        "name": "Game With Array",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1355,
        "index": "C",
        "name": "Count Triangles",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1800,
        "tags": [
            "binary search",
            "implementation",
            "math",
            "two pointers"
        ]
    },
    {
        "contestId": 1355,
        "index": "B",
        "name": "Young Explorers",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "dp",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1355,
        "index": "A",
        "name": "Sequence with Digits",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "brute force",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1354,
        "index": "C1",
        "name": "Simple Polygon Embedding",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "binary search",
            "geometry",
            "math",
            "ternary search"
        ]
    },
    {
        "contestId": 1354,
        "index": "B",
        "name": "Ternary String",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "binary search",
            "dp",
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1354,
        "index": "A",
        "name": "Alarm Clock",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1353,
        "index": "D",
        "name": "Constructing the Array",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "data structures",
            "sortings"
        ]
    },
    {
        "contestId": 1353,
        "index": "C",
        "name": "Board Moves",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1353,
        "index": "B",
        "name": "Two Arrays And Swaps",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1353,
        "index": "A",
        "name": "Most Unstable Array",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1352,
        "index": "G",
        "name": "Special Permutation",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1352,
        "index": "F",
        "name": "Binary String Reconstruction",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "dfs and similar",
            "math"
        ]
    },
    {
        "contestId": 1352,
        "index": "E",
        "name": "Special Elements",
        "type": "PROGRAMMING",
        "rating": 1500,
        "tags": [
            "brute force",
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1352,
        "index": "D",
        "name": "Alice, Bob and Candies",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1352,
        "index": "C",
        "name": "K-th Not Divisible by n",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "binary search",
            "math"
        ]
    },
    {
        "contestId": 1352,
        "index": "B",
        "name": "Same Parity Summands",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1352,
        "index": "A",
        "name": "Sum of Round Numbers",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1351,
        "index": "C",
        "name": "Skier",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1400,
        "tags": [
            "data structures",
            "implementation"
        ]
    },
    {
        "contestId": 1351,
        "index": "B",
        "name": "Square?",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "brute force",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1351,
        "index": "A",
        "name": "A+B (Trial Problem)",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1350,
        "index": "B",
        "name": "Orac and Models",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "dp",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1350,
        "index": "A",
        "name": "Orac and Factors",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1349,
        "index": "A",
        "name": "Orac and LCM",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1600,
        "tags": [
            "data structures",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1348,
        "index": "C",
        "name": "Phoenix and Distribution",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "greedy",
            "sortings",
            "strings"
        ]
    },
    {
        "contestId": 1348,
        "index": "B",
        "name": "Phoenix and Beauty",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "constructive algorithms",
            "data structures",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1348,
        "index": "A",
        "name": "Phoenix and Balance",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1346,
        "index": "E",
        "name": "Magic Tricks",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "*special",
            "dp",
            "graphs"
        ]
    },
    {
        "contestId": 1346,
        "index": "D",
        "name": "Constructing the Dungeon",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "*special",
            "graphs",
            "greedy"
        ]
    },
    {
        "contestId": 1346,
        "index": "C",
        "name": "Spring Cleaning",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "*special",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1346,
        "index": "B",
        "name": "Boot Camp",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "*special",
            "greedy"
        ]
    },
    {
        "contestId": 1346,
        "index": "A",
        "name": "Color Revolution",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "*special",
            "math"
        ]
    },
    {
        "contestId": 1345,
        "index": "B",
        "name": "Card Constructions",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "binary search",
            "brute force",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1345,
        "index": "A",
        "name": "Puzzle Pieces",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1344,
        "index": "A",
        "name": "Hilbert's Hotel",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1600,
        "tags": [
            "math",
            "number theory",
            "sortings"
        ]
    },
    {
        "contestId": 1343,
        "index": "D",
        "name": "Constant Palindrome Sum",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "brute force",
            "data structures",
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1343,
        "index": "C",
        "name": "Alternating Subsequence",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "dp",
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1343,
        "index": "B",
        "name": "Balanced Array",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1343,
        "index": "A",
        "name": "Candies",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "brute force",
            "math"
        ]
    },
    {
        "contestId": 1342,
        "index": "C",
        "name": "Yet Another Counting Problem",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1342,
        "index": "B",
        "name": "Binary Period",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "constructive algorithms",
            "strings"
        ]
    },
    {
        "contestId": 1342,
        "index": "A",
        "name": "Road To Zero",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1341,
        "index": "B",
        "name": "Nastya and Door",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1341,
        "index": "A",
        "name": "Nastya and Rice",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1340,
        "index": "B",
        "name": "Nastya and Scoreboard",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "dp",
            "graphs",
            "greedy"
        ]
    },
    {
        "contestId": 1340,
        "index": "A",
        "name": "Nastya and Strange Generator",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "brute force",
            "data structures",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1339,
        "index": "B",
        "name": "Sorted Adjacent Differences",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "sortings"
        ]
    },
    {
        "contestId": 1339,
        "index": "A",
        "name": "Filling Diamonds",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "brute force",
            "dp",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1338,
        "index": "B",
        "name": "Edge Weight Assignment",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "dfs and similar",
            "greedy",
            "math",
            "trees"
        ]
    },
    {
        "contestId": 1338,
        "index": "A",
        "name": "Powered Addition",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1500,
        "tags": [
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1337,
        "index": "B",
        "name": "Kana and Dragon Quest game",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1337,
        "index": "A",
        "name": "Ichihime and Triangle",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1336,
        "index": "B",
        "name": "Xenia and Colorful Gems",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1700,
        "tags": [
            "binary search",
            "greedy",
            "math",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1336,
        "index": "A",
        "name": "Linova and Kingdom",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1600,
        "tags": [
            "dfs and similar",
            "dp",
            "greedy",
            "sortings",
            "trees"
        ]
    },
    {
        "contestId": 1335,
        "index": "E2",
        "name": "Three Blocks Palindrome (hard version)",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "brute force",
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        "contestId": 1335,
        "index": "E1",
        "name": "Three Blocks Palindrome (easy version)",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "binary search",
            "brute force",
            "data structures",
            "dp",
            "two pointers"
        ]
    },
    {
        "contestId": 1335,
        "index": "D",
        "name": "Anti-Sudoku",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1335,
        "index": "C",
        "name": "Two Teams Composing",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "binary search",
            "greedy",
            "implementation",
            "sortings"
        ]
    },
    {
        "contestId": 1335,
        "index": "B",
        "name": "Construct the String",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1335,
        "index": "A",
        "name": "Candies and Two Sisters",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1334,
        "index": "D",
        "name": "Minimum Euler Cycle",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "graphs",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1334,
        "index": "C",
        "name": "Circle of Monsters",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1334,
        "index": "B",
        "name": "Middle Class",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1334,
        "index": "A",
        "name": "Level Statistics",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1333,
        "index": "C",
        "name": "Eugene and an array",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1700,
        "tags": [
            "binary search",
            "data structures",
            "implementation",
            "two pointers"
        ]
    },
    {
        "contestId": 1333,
        "index": "B",
        "name": "Kind Anton",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1100,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1333,
        "index": "A",
        "name": "Little Artem",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "constructive algorithms"
        ]
    },
    {
        "contestId": 1332,
        "index": "D",
        "name": "Walk on Matrix",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "math"
        ]
    },
    {
        "contestId": 1332,
        "index": "C",
        "name": "K-Complete Word",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "dfs and similar",
            "dsu",
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1332,
        "index": "B",
        "name": "Composite Coloring",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1332,
        "index": "A",
        "name": "Exercising Walk",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1100,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1330,
        "index": "B",
        "name": "Dreamoon Likes Permutations",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1330,
        "index": "A",
        "name": "Dreamoon and Ranking Collection",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1329,
        "index": "B",
        "name": "Dreamoon Likes Sequences",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "combinatorics",
            "math"
        ]
    },
    {
        "contestId": 1329,
        "index": "A",
        "name": "Dreamoon Likes Coloring",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1328,
        "index": "D",
        "name": "Carousel",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "dp",
            "graphs",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1328,
        "index": "C",
        "name": "Ternary XOR",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1328,
        "index": "B",
        "name": "K-th Beautiful String",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "binary search",
            "brute force",
            "combinatorics",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1328,
        "index": "A",
        "name": "Divisibility Problem",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1327,
        "index": "E",
        "name": "Count The Blocks",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "combinatorics",
            "dp",
            "math"
        ]
    },
    {
        "contestId": 1327,
        "index": "C",
        "name": "Game with Chips",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "constructive algorithms",
            "implementation"
        ]
    },
    {
        "contestId": 1327,
        "index": "B",
        "name": "Princesses and Princes",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "brute force",
            "graphs",
            "greedy"
        ]
    },
    {
        "contestId": 1327,
        "index": "A",
        "name": "Sum of Odd Integers",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1326,
        "index": "D2",
        "name": "Prefix-Suffix Palindrome (Hard version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1800,
        "tags": [
            "binary search",
            "greedy",
            "hashing",
            "string suffix structures",
            "strings"
        ]
    },
    {
        "contestId": 1326,
        "index": "D1",
        "name": "Prefix-Suffix Palindrome (Easy version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "hashing",
            "string suffix structures",
            "strings"
        ]
    },
    {
        "contestId": 1326,
        "index": "C",
        "name": "Permutation Partitions",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "combinatorics",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1326,
        "index": "B",
        "name": "Maximums",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 900,
        "tags": [
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1326,
        "index": "A",
        "name": "Bad Ugly Numbers",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "number theory"
        ]
    },
    {
        "contestId": 1325,
        "index": "D",
        "name": "Ehab the Xorcist",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1700,
        "tags": [
            "bitmasks",
            "constructive algorithms",
            "greedy",
            "number theory"
        ]
    },
    {
        "contestId": 1325,
        "index": "C",
        "name": "Ehab and Path-etic MEXs",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1500,
        "tags": [
            "constructive algorithms",
            "dfs and similar",
            "greedy",
            "trees"
        ]
    },
    {
        "contestId": 1325,
        "index": "B",
        "name": "CopyCopyCopyCopyCopy",
        "type": "PROGRAMMING",
        "points": 750,
        "rating": 800,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1325,
        "index": "A",
        "name": "EhAb AnD gCd",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "constructive algorithms",
            "greedy",
            "number theory"
        ]
    },
    {
        "contestId": 1324,
        "index": "F",
        "name": "Maximum White Subtree",
        "type": "PROGRAMMING",
        "rating": 1800,
        "tags": [
            "dfs and similar",
            "dp",
            "graphs",
            "trees"
        ]
    },
    {
        "contestId": 1324,
        "index": "E",
        "name": "Sleeping Schedule",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "dp",
            "implementation"
        ]
    },
    {
        "contestId": 1324,
        "index": "D",
        "name": "Pair of Topics",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "binary search",
            "data structures",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1324,
        "index": "C",
        "name": "Frog Jumps",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "binary search",
            "data structures",
            "dfs and similar",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1324,
        "index": "B",
        "name": "Yet Another Palindrome Problem",
        "type": "PROGRAMMING",
        "rating": 1100,
        "tags": [
            "brute force",
            "strings"
        ]
    },
    {
        "contestId": 1324,
        "index": "A",
        "name": "Yet Another Tetris Problem",
        "type": "PROGRAMMING",
        "rating": 900,
        "tags": [
            "implementation",
            "number theory"
        ]
    },
    {
        "contestId": 1323,
        "index": "B",
        "name": "Count Subrectangles",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "binary search",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1323,
        "index": "A",
        "name": "Even Subset Sum Problem",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "dp",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1322,
        "index": "A",
        "name": "Unusual Competitions",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1300,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1321,
        "index": "C",
        "name": "Remove Adjacent",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1600,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1321,
        "index": "A",
        "name": "Contest for Robots",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1320,
        "index": "B",
        "name": "Navigation System",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "dfs and similar",
            "graphs",
            "shortest paths"
        ]
    },
    {
        "contestId": 1320,
        "index": "A",
        "name": "Journey Planning",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1400,
        "tags": [
            "data structures",
            "dp",
            "greedy",
            "math",
            "sortings"
        ]
    },
    {
        "contestId": 1316,
        "index": "C",
        "name": "Primitive Primes",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "math",
            "ternary search"
        ]
    },
    {
        "contestId": 1316,
        "index": "B",
        "name": "String Modification",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1400,
        "tags": [
            "brute force",
            "constructive algorithms",
            "implementation",
            "sortings",
            "strings"
        ]
    },
    {
        "contestId": 1316,
        "index": "A",
        "name": "Grade Allocation",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1315,
        "index": "C",
        "name": "Restoring Permutation",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1200,
        "tags": [
            "greedy"
        ]
    },
    {
        "contestId": 1315,
        "index": "B",
        "name": "Homecoming",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "binary search",
            "dp",
            "greedy",
            "strings"
        ]
    },
    {
        "contestId": 1315,
        "index": "A",
        "name": "Dead Pixel",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "implementation"
        ]
    },
    {
        "contestId": 1313,
        "index": "C1",
        "name": "Skyscrapers (easy version)",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1500,
        "tags": [
            "brute force",
            "data structures",
            "dp",
            "greedy"
        ]
    },
    {
        "contestId": 1313,
        "index": "B",
        "name": "Different Rules",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1700,
        "tags": [
            "constructive algorithms",
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1313,
        "index": "A",
        "name": "Fast Food Restaurant",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 900,
        "tags": [
            "brute force",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1312,
        "index": "D",
        "name": "Count the Arrays",
        "type": "PROGRAMMING",
        "rating": 1700,
        "tags": [
            "combinatorics",
            "math"
        ]
    },
    {
        "contestId": 1312,
        "index": "C",
        "name": "Adding Powers",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "bitmasks",
            "greedy",
            "implementation",
            "math",
            "number theory",
            "ternary search"
        ]
    },
    {
        "contestId": 1312,
        "index": "B",
        "name": "Bogosort",
        "type": "PROGRAMMING",
        "rating": 1000,
        "tags": [
            "constructive algorithms",
            "sortings"
        ]
    },
    {
        "contestId": 1312,
        "index": "A",
        "name": "Two Regular Polygons",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "geometry",
            "greedy",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1311,
        "index": "C",
        "name": "Perform the Combo",
        "type": "PROGRAMMING",
        "rating": 1300,
        "tags": [
            "brute force"
        ]
    },
    {
        "contestId": 1311,
        "index": "B",
        "name": "WeirdSort",
        "type": "PROGRAMMING",
        "rating": 1200,
        "tags": [
            "dfs and similar",
            "sortings"
        ]
    },
    {
        "contestId": 1311,
        "index": "A",
        "name": "Add Odd or Subtract Even",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "greedy",
            "implementation",
            "math"
        ]
    },
    {
        "contestId": 1310,
        "index": "A",
        "name": "Recommendations",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 1700,
        "tags": [
            "data structures",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1307,
        "index": "C",
        "name": "Cow and Message",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "brute force",
            "dp",
            "math",
            "strings"
        ]
    },
    {
        "contestId": 1307,
        "index": "B",
        "name": "Cow and Friend",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1300,
        "tags": [
            "geometry",
            "greedy",
            "math"
        ]
    },
    {
        "contestId": 1307,
        "index": "A",
        "name": "Cow and Haybales",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1305,
        "index": "C",
        "name": "Kuroni and Impossible Calculation",
        "type": "PROGRAMMING",
        "points": 1250,
        "rating": 1600,
        "tags": [
            "brute force",
            "combinatorics",
            "math",
            "number theory"
        ]
    },
    {
        "contestId": 1305,
        "index": "B",
        "name": "Kuroni and Simple Strings",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1200,
        "tags": [
            "constructive algorithms",
            "greedy",
            "strings",
            "two pointers"
        ]
    },
    {
        "contestId": 1305,
        "index": "A",
        "name": "Kuroni and the Gifts",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "sortings"
        ]
    },
    {
        "contestId": 1304,
        "index": "D",
        "name": "Shortest and Longest LIS",
        "type": "PROGRAMMING",
        "points": 1750,
        "rating": 1800,
        "tags": [
            "constructive algorithms",
            "graphs",
            "greedy",
            "two pointers"
        ]
    },
    {
        "contestId": 1304,
        "index": "C",
        "name": "Air Conditioner",
        "type": "PROGRAMMING",
        "points": 1500,
        "rating": 1500,
        "tags": [
            "dp",
            "greedy",
            "implementation",
            "sortings",
            "two pointers"
        ]
    },
    {
        "contestId": 1304,
        "index": "B",
        "name": "Longest Palindrome",
        "type": "PROGRAMMING",
        "points": 1000,
        "rating": 1100,
        "tags": [
            "brute force",
            "constructive algorithms",
            "greedy",
            "implementation",
            "strings"
        ]
    },
    {
        "contestId": 1304,
        "index": "A",
        "name": "Two Rabbits",
        "type": "PROGRAMMING",
        "points": 500,
        "rating": 800,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1303,
        "index": "C",
        "name": "Perfect Keyboard",
        "type": "PROGRAMMING",
        "rating": 1600,
        "tags": [
            "dfs and similar",
            "greedy",
            "implementation"
        ]
    },
    {
        "contestId": 1303,
        "index": "B",
        "name": "National Project",
        "type": "PROGRAMMING",
        "rating": 1400,
        "tags": [
            "math"
        ]
    },
    {
        "contestId": 1303,
        "index": "A",
        "name": "Erasing Zeroes",
        "type": "PROGRAMMING",
        "rating": 800,
        "tags": [
            "implementation",
            "strings"
        ]
    }
]

export default prob;